// ---------------------------------------------------------------------------
// Binning
// ---------------------------------------------------------------------------

export type BinningMode = 'count' | 'width' | 'custom';

export interface BinningCountConfig {
  readonly mode: 'count';
  readonly binCount: number;
}

export interface BinningWidthConfig {
  readonly mode: 'width';
  readonly binWidth: number;
}

export interface BinningCustomConfig {
  readonly mode: 'custom';
  readonly boundaries: number[];
}

export type BinningConfig = BinningCountConfig | BinningWidthConfig | BinningCustomConfig;

// ---------------------------------------------------------------------------
// Y-axis
// ---------------------------------------------------------------------------

export type YAxisType = 'frequency' | 'relative-frequency' | 'frequency-density';

export const Y_AXIS_LABELS: Record<YAxisType, string> = {
  frequency: 'Frequency',
  'relative-frequency': 'Relative frequency (%)',
  'frequency-density': 'Frequency density (%)',
};

// ---------------------------------------------------------------------------
// Histogram config
// ---------------------------------------------------------------------------

export interface HistogramConfig {
  readonly binning: BinningConfig;
  readonly yAxisType: YAxisType;
  /** null = auto (use data min) */
  readonly startBoundary: number | null;
}

export const DEFAULT_HISTOGRAM_CONFIG: HistogramConfig = {
  binning: { mode: 'count', binCount: 10 },
  yAxisType: 'frequency',
  startBoundary: null,
};

// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface HistogramParams {
  /** Raw data values to bin into a histogram */
  readonly data: number[];
  /** Histogram configuration */
  readonly config: HistogramConfig;
}

// ---------------------------------------------------------------------------
// Display
// ---------------------------------------------------------------------------

export interface HistogramDisplayConfig {
  readonly barColor?: string;
  readonly showFrequencyLabels?: boolean;
  readonly xAxisLabel?: string;
  readonly yAxisLabel?: string;
}

export const DEFAULT_HISTOGRAM_DISPLAY: HistogramDisplayConfig = {
  barColor: '#5470c6',
  showFrequencyLabels: true,
  xAxisLabel: 'Value',
};
